import { LoaderFunction, redirect } from 'react-router-dom';
import { IComposeAppRendererParams } from '@opengov/compose-app/renderApp';
import { getSessionEntitySubdomain } from '@opengov/app-core/session/selectors';

export const rootLoader =
  (store: IComposeAppRendererParams<object>['store']): LoaderFunction<unknown> =>
  () => {
    // This only runs on the bare `/reporting` index route, where there is no entity in the
    // URL. The v1 session entity is therefore the only available source for the redirect
    // target. In PSP this is correct only if the auth session reflects the platform-selected
    // entity (see useCheckSession re-auth chain); reporting cannot otherwise know the
    // selected entity here. PSP entrypoints should link to `/reporting/:entitySubdomain`
    // (handled by verifyRequestedEntity) rather than bare `/reporting` to avoid relying on
    // the home-entity fallback.
    const userEntitySubdomain = getSessionEntitySubdomain(store.getState());
    if (userEntitySubdomain) {
      return redirect(`/${userEntitySubdomain}`);
    }
    return null;
  };
